export const canUseDom = (): boolean =>
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    !!(
        typeof window !== 'undefined' &&
        typeof window.document === 'object' &&
        typeof window.document.createElement === 'function'
    );

export const canUseHistory = () => typeof window !== 'undefined' && typeof window.history.pushState === 'function';

export const canUseLocation = () => typeof window !== 'undefined' && typeof window.location.href === 'string';
